import { ConcreteEncodable } from "./ConcreteEncodable";

import { BlotterDefinitionImplEncoder } from "../../encoder/BlotterDefinitionImplEncoder";

import * as CubiqTS from "../../index";
import { BlotterDefinition } from "../BlotterDefinition";

export class BlotterDefinitionImpl extends ConcreteEncodable implements BlotterDefinition {
  public static enType: string = "com.bcdfx.model.BlotterDefinitionImpl";

  /*FID=1*/
  public blotterId: CubiqTS.Long | null = null;
  /*FID=2*/
  public blotterName: string;
  /*FID=3*/
  public entryUserId: CubiqTS.Long | null = null;
  /*FID=4*/
  public creationDts: CubiqTS.moment.Moment | null = null;
  /*FID=5*/
  public blotterType: CubiqTS.BlotterType;
  /*FID=6*/
  public queryGroup: CubiqTS.QueryGroup | null = null;
  /*FID=7*/
  public isSystemBlotter: boolean;
  /*FID=8*/
  public assetClass: CubiqTS.AssetClass;
  /*FID=9*/
  public lastUpdateDts: CubiqTS.moment.Moment | null = null;
  /*FID=100*/
  public messageId: string;
  public sessionOnly: string;

  constructor() {
    super();
    this.encoder = BlotterDefinitionImplEncoder.Instance;
    this.setEncodableType(BlotterDefinitionImpl.enType);
    //Model
  }

  public toString(): string {
    return (
      "BlotterDefinitionImpl[" +
      "blotterId=" +
      this.blotterId +
      "blotterName=" +
      this.blotterName +
      "entryUserId=" +
      this.entryUserId +
      "creationDts=" +
      this.creationDts +
      "blotterType=" +
      this.blotterType +
      "queryGroup=" +
      this.queryGroup +
      "isSystemBlotter=" +
      this.isSystemBlotter +
      "assetClass=" +
      this.assetClass +
      "lastUpdateDts=" +
      this.lastUpdateDts +
      "messageId=" +
      this.messageId +
      "]"
    );
  }

  public validateInbound(): void {}

  public validateOutbound(): void {}
}
